import { deserialize, deserializeAs, inheritSerialization } from 'cerialize';
import { Entity } from './entity';

@inheritSerialization(Entity)
export class Conseil extends Entity {

  @deserialize
  titre: string = null;

  @deserialize
  image: any = null;

  @deserialize
  contenu: string = null;

  @deserializeAs('updated_at')
  date: Date = null;
}
